import { mapActions } from 'vuex';
import Events from '_utils/events';
import BannerService from '_services/rest/modules/banner';

export default {
  name: 'banner-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      BannerService.deleteBanner(this.selectBanner)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', { page: 1 });
          this.activeAlert({ message: 'Banner deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
